<template>
  <section v-if="lang['hotel_mobile_new']">
    <Title :title-name="pageTitle" :title-link="title.NoHotelsAvailable.titleLink" />
    <div class="container">
      <div class="my-4">
        <ItemOfVouchers icon="hotel-voucher" color="#f0725e" :label="lang['hotel_mobile_new'].SFS_LANG_ROW_1" border />
      </div>
      <div v-if="availableChangeMatrix" class="ws-textbox mt-4 mb-4">
        <div class="change-room-allocation title-right-on-arabic" @click="changeRoomAllocation()">
          {{ lang['hotel_mobile_new'].SFS_LANG_ROW_79 || 'Change Room allocation' }}
        </div>
      </div>
      <div class="ws-textbox">
        <img :src="`${$publicPath}images/icon-voucher/warning.png`" alt="" srcset="" class="img-voucher" />
        <p v-html="lang['hotel_mobile_new'].SFS_LANG_ROW_27"></p>
      </div>
    </div>
  </section>
</template>

<script>
import Title from '@/components/Title/index'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'

export default {
  name: 'NoHotelsAvailable',
  components: { Title, ItemOfVouchers },

  beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    clearInterval(this.idIntervalProgressBar)
    clearInterval(this.idIntervalLoadHotels)
    next()
  },

  props: {
    secret: {
      type: String,
      default: ''
    },
    hasBookedFailed: {
      type: Boolean
    }
  },
  data() {
    return {
      progressBarWidth: 10,
      idIntervalProgressBar: null,
      idIntervalLoadHotels: null,
      timeRefeshPage: 300000
    }
  },
  computed: {
    pageTitle() {
      const { lang } = this
      return lang && lang.hotel_mobile_new && this.lang.hotel_mobile_new.SFS_LANG_ROW_28
        ? lang.hotel_mobile_new.SFS_LANG_ROW_28
        : 'Home'
    },
    availableChangeMatrix() {
      return this.PaxsGroup.length > 1 ? true : false
    }
  },
  watch: {
    pax: {
      handler: function () {
        this.onRunLoadHotels()
        this.onRunProgressBar()
      },
      deep: true
    }
  },
  mounted() {
    this.onRunProgressBar()
    this.onRunLoadHotels()
  },

  beforeUnmount() {
    clearInterval(this.idIntervalProgressBar)
    clearInterval(this.idIntervalLoadHotels)
  },

  methods: {
    onRunProgressBar() {
      if (this.pax.diff_day === 1) {
        clearInterval(this.idIntervalProgressBar)
        const self = this
        this.idIntervalProgressBar = setInterval(function () {
          if (self.progressBarWidth >= 100) {
            self.progressBarWidth = 0
          }
          self.progressBarWidth = self.progressBarWidth + 1
        }, 50)
      }
    },

    onRunLoadHotels() {
      if (this.pax.diff_day === 1) {
        clearInterval(this.idIntervalLoadHotels)
        const self = this
        this.idIntervalLoadHotels = setInterval(function () {
          self.$router.push({
            path: '/hotel-list',
            query: { secret: self.secret }
          })
        }, self.timeRefeshPage)
      }
    },
    
    changeRoomAllocation() {
      this.$router.push({ path: '/hotel-book', query: { secret: this.secret } })
    }
  }
}
</script>

<style lang="scss" scoped>
#myBar {
  width: 10%;
  height: 15px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}
#myProgress {
  width: 80%;
  margin: auto;
  background-color: #ddd;
}
.ws-textbox {
  text-align: center;
}
.ws-textbox p {
  margin-top: 20px;
  color: #6a6b6bf0;
  line-height: 33px;
  font-size: 21px;
}
.change-room-allocation {
  text-align: left;
}
.change-room-allocation:hover {
    cursor: pointer;
}
</style>
